<template>
  <div class="introduction-container">
    <div class="breadcrumbs mb-40">
      <breadcrumb path="/documentation/introduction" name="Homepage" :routeName="route.name" />
    </div>
    <section id="1">
      <div class="title">
        {{ $t('privacy_policy.title') }}
      </div>
      <div class="submenu-container mb-40">
        <div class="mb-10">
          {{ $t('privacy_policy.description') }}
        </div>
        <div class="mb-10">
          <ol>
            <li>{{ $t('privacy_policy.privacy1') }}</li>
            <li>{{ $t('privacy_policy.privacy2') }}</li>
            <li>{{ $t('privacy_policy.privacy3') }}</li>
          </ol>
        </div>
      </div>
    </section>
    <section id="2">
      <div class="title">
        {{ $t('information.title') }}
      </div>
      <div class="submenu-container mb-40">
        <div class="mb-10">
          {{ $t('privacy_policy.description') }}
        </div>
        <div class="mb-10">
          <ol>
            <li>{{ $t('privacy_policy.privacy1') }}</li>
            <li>{{ $t('privacy_policy.privacy2') }}</li>
            <li>{{ $t('privacy_policy.privacy3') }}</li>
          </ol>
        </div>
      </div>
    </section>
    <section id="3">
      <div class="title">
        {{ $t('security.title') }}
      </div>
      <div class="submenu-container mb-40">
        <div class="mb-10">
          {{ $t('security.description') }}
          {{ $t('security.email', { account: 'support', domain: 'olsera.com' }) }}.
        </div>
      </div>
    </section>
    <section id="4">
      <div class="title">
        {{ $t('disclosure.title') }}
      </div>
      <div class="submenu-container mb-40">
        <div class="mb-10">
          {{ $t('disclosure.description1') }}<br/>
          {{ $t('disclosure.description2') }}
        </div>
      </div>
    </section>
    <section id="5">
      <div class="title">
        {{ $t('cookies.title') }}
      </div>
      <div class="submenu-container mb-40">
        <div class="mb-10">
          {{ $t('cookies.description') }}
        </div>
      </div>
    </section>
    <section id="6">
      <div class="title">
        {{ $t('google_analytics.title') }}
      </div>
      <div class="submenu-container mb-40">
        <div class="mb-10">
          {{ $t('google_analytics.description') }}
        </div>
      </div>
    </section>
    <section id="7">
      <div class="title">
        {{ $t('changes_privacy.title') }}
      </div>
      <div class="submenu-container mb-40">
        <div class="mb-10">
          {{ $t('changes_privacy.description') }}
        </div>
      </div>
    </section>
    <section id="8">
      <div class="title">
        {{ $t('data_deletion.title') }}
      </div>
      <div class="submenu-container mb-40">
        <div class="mb-10">
          {{ $t('data_deletion.description') }}
          {{ $t('data_deletion.email', { account: 'support', domain: 'olsera.com' }) }}.
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

const route = useRoute()
</script>

<style lang="scss" scoped>
.submenu-container {
  max-width: 75%;
}
</style>
